import { booleanAttribute, ChangeDetectionStrategy, Component, HostBinding, input, Input, output } from '@angular/core';

@Component({
  selector: 'pp-title',
  imports: [],
  templateUrl: './title.component.html',
  styleUrl: './title.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TitleComponent {
  readonly title = input<string>();
  readonly clicked = output<void>();

  @HostBinding('class.clickable')
  @Input({ transform: booleanAttribute })
  clickable = false;
}
